import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { OnyxBrandMark } from './OnyxBrandMark';
import { OnyxNav } from './OnyxNav';
import './PageShell.css';
import './admin-page-bounds.css';

/**
 * Canonical page shell.
 * width: page (centered) | full (edge-to-edge)
 * height: auto (document scroll) | viewport (locked panes)
 */
export function OnyxPageShell({
  brand = 'Onyx :: Lighthouse',
  children,
  actions = null,
  className = '',
  withAppNav = false,
  announcement,
  hideBrandHeader = false,
  width = 'page',
  height = 'auto',
}) {
  return (
    <div
      className={[
        'onyx-page-shell',
        withAppNav ? 'onyx-page-shell--with-nav' : '',
        `onyx-page-shell--width-${width}`,
        `onyx-page-shell--height-${height}`,
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-page-shell"
      data-with-nav={withAppNav ? 'true' : 'false'}
      data-width={width}
      data-height={height}
    >
      {withAppNav ? <OnyxNav announcement={announcement} /> : null}
      {!hideBrandHeader && !withAppNav ? (
        <header className="onyx-page-shell__header">
          <div className="onyx-page-shell__brand-row">
            <OnyxBrandMark size={32} />
            <Typography variant="brandDisplay" component="h1" className="onyx-page-shell__brand">
              {brand}
            </Typography>
          </div>
          {actions}
        </header>
      ) : null}
      {withAppNav && actions ? (
        <div className="onyx-page-shell__actions">{actions}</div>
      ) : null}
      <div className="onyx-page-shell__content">{children}</div>
    </div>
  );
}

OnyxPageShell.propTypes = {
  brand: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string,
  withAppNav: PropTypes.bool,
  announcement: PropTypes.string,
  hideBrandHeader: PropTypes.bool,
  width: PropTypes.oneOf(['page', 'full']),
  height: PropTypes.oneOf(['auto', 'viewport']),
};

export const PageShell = OnyxPageShell;
